"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTableRow = exports.StyledTable = exports.StyledItemCell = exports.StyledHeaderCell = exports.ItemCell = exports.HeaderCell = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("./constants");
const StyledTable = exports.StyledTable = (0, _mui.styled)(_mui.Table)({
  width: 'fit-content',
  borderSpacing: 0,
  borderCollapse: 'collapse'
});
const StyledHeaderCell = exports.StyledHeaderCell = (0, _mui.styled)(_mui.TableCell, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['minWidth', 'maxWidth'])
})(({
  theme,
  minWidth,
  maxWidth
}) => ({
  minWidth: minWidth ?? _constants.CELL_MIN_WIDTH,
  maxWidth: maxWidth ?? _constants.CELL_MAX_WIDTH,
  backgroundColor: theme.palette.primary.light,
  padding: theme.spacing(2, 4),
  borderBottom: `1px solid ${theme.palette.blueGrey[200]}`,
  borderTop: `1px solid ${theme.palette.blueGrey[200]}`,
  '&:first-child': {
    borderLeft: `1px solid ${theme.palette.blueGrey[200]}`
  },
  '&:last-child': {
    borderRight: `1px solid ${theme.palette.blueGrey[200]}`
  }
}));
const HeaderCell = exports.HeaderCell = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['maxLines'])
})(({
  maxLines
}) => ({
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: maxLines ?? _constants.HEADER_CELL_MAX_LINES,
  WebkitBoxOrient: 'vertical'
}));
const StyledItemCell = exports.StyledItemCell = (0, _mui.styled)(_mui.TableCell, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['minWidth', 'maxWidth'])
})(({
  theme,
  minWidth,
  maxWidth
}) => ({
  minWidth: minWidth ?? _constants.CELL_MIN_WIDTH,
  maxWidth: maxWidth ?? _constants.CELL_MAX_WIDTH,
  padding: theme.spacing(2, 4),
  borderBottom: `1px solid ${theme.palette.blueGrey[200]}`
}));
const ItemCell = exports.ItemCell = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['maxLines'])
})(({
  maxLines
}) => ({
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: maxLines ?? _constants.ITEM_CELL_MAX_LINES,
  WebkitBoxOrient: 'vertical'
}));
const StyledTableRow = exports.StyledTableRow = (0, _mui.styled)(_mui.TableRow)(({
  theme
}) => ({
  borderLeft: `1px solid ${theme.palette.blueGrey[200]}`,
  borderRight: `1px solid ${theme.palette.blueGrey[200]}`
}));
//# sourceMappingURL=styles.js.map